module.exports = __webpack_public_path__ + "img/demand-list.db90771f.png";